<template>
  <div class="relative w-full">
    <div class="flex items-center space-x-6 w-full tracking-wide">
      <template v-for="link in menuItems" :key="link.label">
        <ULink
          :to="$localePath(link.to)"
          active-class="text-brand underline underline-offset-8 decoration-brand"
          class="font-semibold hover:text-brand duration-200 text-lg transition-colors"
        >
          {{ $t(link.label) }}
        </ULink>
      </template>

      <div class="flex items-center grow space-x-4 justify-end">
        <ULink
          size="xl"
          :to="$localePath({ name: 'become-partner' })"
          active-class="!text-brand underline underline-offset-8 decoration-brand"
          :padded="false"
          class="text-gray-900 font-medium text-[1rem] hover:text-brand duration-200"
        >
          {{ $t("general.becomePartner") }}
        </ULink>
        <ASelectUiLocale />
        <UButton
          v-if="!$me?.agencyId"
          size="xl"
          :to="$localePath({ name: 'quote-steps-01-destinations' })"
          class="shadow rounded-full px-4 font-semibold text-base"
        >
          {{ $t("elements.header.createTrip") }}
        </UButton>
        <UButton
          v-if="!$me"
          size="xl"
          color="white"
          :ui="{
            icon: {
              base: 'h-7 w-7 text-gray-600',
            },
          }"
          icon="mdi:account-circle"
          class="shadow rounded-full size-11 px-0 place-content-center font-semibold text-base"
          @click="authFormModal.open()"
        ></UButton>

        <UButton
          v-else
          :to="$localePath({ name: 'account' })"
          size="xl"
          color="white"
          class="shadow rounded-full size-11 place-content-center gap-x-1 pr-3 items-center font-bold"
        >
          <UAvatar
            size="lg"
            class="!size-7 bg-transparent ring-0"
            :ui="{ placeholder: 'text-neutral-700 text-[1.05rem] font-bold' }"
            :alt="`${$me.fullname}`"
          />
        </UButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { menuItems } = storeToRefs(useMenuStore())
const { authFormModal } = useAuthFormModal()
const { $localePath, $me } = useNuxtApp()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
